import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import Cookies from "js-cookie";

const isEncryptionEnabled = process.env.REACT_APP_IS_ENCRYPTION === "true";

// Add Company management Api

export const createCareersList = async (data) => {
    const access_token = Cookies.get("access_token");

    const payload = isEncryptionEnabled
        ? { reqData: encryptData({ ...data, access_token }) }
        : { ...data, access_token };

    try {
        const response = await axios.post(`/add-career`, payload);
        const decrypted = isEncryptionEnabled ? decryptData(response) : response.data;
        return decrypted;
    } catch (error) {
        console.error("Error inside createCareersList:", error);
        throw error;
    }
};